//************************************************************************ /
// STORY CTA CARD
// Transparent card spanning two columns that invites users to post a story.
//************************************************************************ /

import React from "react";
import {
  Card,
  Button,
  Group,
  Typography,
} from "@dreambigger/design-system/src/components";
import { useGA, useMixpanel, useSegment } from "@dreambigger/shared/src/hooks";
import anim from "@dreambigger/shared/src/components/board/styles/animations.module.scss";
import { useRouter } from "next/router";
import InspireAnalytics, {
  InspireAnalyticsHelper,
  InspireAnalyticEvents,
} from "@dreambigger/shared/src/utils/inspire-analytics-helper";

const { Title, Text } = Typography;

export interface StoryCtaCardProps {
  cardTitle: string;
  cardText: string;
  buttonText: string;
  buttonUrl: string;
}

const StoryCtaCard = ({
  cardTitle,
  cardText,
  buttonUrl,
  buttonText,
}: StoryCtaCardProps) => {
  // If no button url, do not render card.
  if (!buttonUrl) {
    return <></>;
  }
  const router = useRouter();

  // Load analytics
  const googleAnalytics = useGA();
  const mixpanel = useMixpanel();
  const segment = useSegment();

  const handleCardClick = () => {
    // Log analytics for clicking card.
    googleAnalytics.event({
      category: "Story Share Flow",
      action: "Select",
      label: "Share Story - Has Image/No Image",
      value: 1,
    });
    InspireAnalytics.track({
      eventName: InspireAnalyticEvents.CARD_SELECTED,
      properties: {
        "Card Type": "widestorysharecta",
        "Page Type": InspireAnalyticsHelper.getPageType(router.route),
      },
      mixpanel,
      segment,
    });
    // Redirect to href
    window.location.pathname = buttonUrl;
  };

  return (
    <Card
      className={`${anim.enter_f} lift bg-white pointer h-100 w-100 flex items-center justify-center`}
      onClick={handleCardClick}
    >
      <Group spacing={5} className="items-center tc">
        {/* Call To Action Text */}
        <Title level={4} className="mb-2">
          {cardTitle}
        </Title>
        <Text>{cardText}</Text>
        {/* Button Link */}

        <Button
          type="primary"
          className="bg-primary b-primary lightenPrimaryBkd primaryText ttu"
          onClick={handleCardClick}
        >
          {buttonText}
        </Button>
      </Group>
    </Card>
  );
};

export default StoryCtaCard;
